import { render, staticRenderFns } from "./Statistic2.vue?vue&type=template&id=35a13463&scoped=true&"
import script from "./Statistic2.vue?vue&type=script&lang=js&"
export * from "./Statistic2.vue?vue&type=script&lang=js&"
import style0 from "./Statistic2.vue?vue&type=style&index=0&id=35a13463&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a13463",
  null
  
)

export default component.exports